/**
 * My Library icon for sidebar navigation (Figma design).
 */

import React from "react";
import type { IconProps } from "./types";

const MyLibraryIcon: React.FC<IconProps> = ({
  size = 20,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.238 5.875a1.759 1.759 0 00-1.733-2.063H5.493a1.759 1.759 0 00-1.732 2.063"
      stroke={color}
      strokeWidth={1.3}
    />
    <path
      d="M14.537 3.813c.024-.214.035-.321.035-.41A1.65 1.65 0 0013.1 1.76c-.088-.009-.196-.009-.41-.009H7.31c-.215 0-.323 0-.41.01-.84.09-1.476.8-1.474 1.644 0 .088.012.195.035.409"
      stroke={color}
      strokeWidth={1.3}
    />
    <path
      d="M17.585 13.954c-.289 2.047-.433 3.07-1.173 3.683s-1.832.613-4.016.613H7.604c-2.184 0-3.275 0-4.016-.613-.74-.613-.884-1.636-1.173-3.683l-.349-2.475c-.368-2.61-.552-3.915.23-4.76.782-.844 2.175-.844 4.959-.844h5.49c2.785 0 4.177 0 4.959.845.617.667.632 1.622.43 3.28"
      stroke={color}
      strokeWidth={1.3}
      strokeLinecap="round"
    />
    <path
      d="M12.13 11.333c.46.286.46 1.025 0 1.31L9.35 14.369c-.448.278-.998-.083-.998-.655v-3.449c0-.571.55-.932.998-.655l2.781 1.724z"
      stroke={color}
      strokeWidth={1.3}
    />
  </svg>
);

export default MyLibraryIcon;
